import dashboard from './dashboard.js'
import users from './users/index.js'
import products from './products/index.js'
import sales from './sales/index.js'
import purchases from './purchases/index.js'
import warehousing from './warehousing/index.js'
import treasury from './treasury/index.js'
import accountancy from './accountancy/index.js'
import reports from './reports.js'
import events from './events.js'
import companies from './companies.js'
import plugins from './plugins/index.js'
import tickets from './tickets.js'
import setting from './setting/index.js'
import login from './login.js'
import profile from './profile.js'
import notFound from './notFound.js'
import companyInfo from './companyInfo.js'

export default {
  dashboard,
  users,
  products,
  sales,
  purchases,
  warehousing,
  treasury,
  accountancy,
  reports,
  events,
  companies,
  plugins,
  tickets,
  setting,
  login,
  profile,
  notFound,
  companyInfo
}
